export enum FeatureFlags {
  ADMIN_TEAMS_FACILITIES_ADD_FACILITY = 'admin_teams_facilities_add_facility',
  AI_INSIGHTS_ENABLED = 'enable_ai_insights',
  CHART_FIXED_INR_FORMAT = 'chart_fixed_inr_format',
  CUSTOM_POP_AG_GRID = 'custom_pop_ag_grid',
  DRAGONFLY_ASYNC_MODE = 'dragonfly_async_mode',
  ENABLE_DRAGONFLY_SEARCH_RETRY = 'enable_dragonfly_search_retry',
  ENABLE_GEN_AI_P2P_PA_CLINICAL_SUMMARY = 'enable_gen_ai_p2p_pa_clinical_summary',
  ENG_3403_FIX_INSERT_INTO_ENTITY_OUTBOUND_REVIEW_LOG = 'eng_3403_fix_insert_into_entity_outbound_review_log',
  ENG_3590_REMOVE_DUPLICATE_REVIEWS_ON_REPORTING_PAGE = 'eng_3590_remove_duplicate_reviews_on_reporting_page',
  EVENT_REVIEW_AUTOSAVE = 'event_review_autosave',
  P2P_GEN_AI = 'p2p_gen_ai',
  PA_MERLOT_CONNECTION = 'pa_merlot_connection',
  PA_MERLOT_PARITY = 'pa_merlot_parity',
  PA_ROADRUNNER_PARITY = 'pa_roadrunner_parity',
  PARR_INTEROPERABILITY = 'parr_interoperability',
  QUEUE_PA_STATUS_INDICATOR_P2P = 'queue_pa_status_indicator_p2p',
  REVIEW_AUTOSAVE = 'review_autosave',
  REVIEW_MULTIPLE_COMMENTS = 'review_multiple_comments',
  REVIEW_PREVENT_MULTIPLE_OPEN = 'review_prevent_multiple_open',
  REVIEWERS_USES_CACHE = 'reviewers_uses_cache',
  REVIEWS = 'reviews',
  REVIEWS_VIEW_CHART_BTN = 'reviews_view_chart_btn',
  SYSTEM_BYPASS_SCRUBBED = 'system_bypass_scrubbed',
  TEAMS_CREATE_NEW_USER_TYPE_AND_NEW_USER = 'teams_create_new_user_type_and_new_user',
}

export const BOOLEAN_TRUE_STRING = 'true';
export const EMPTY_STRING = '';
export const NONE = 'none';
export const NA_STRING = 'N/A';
export const ASTERISK_STRING = '*';
export const SELECT_ALL = 'Select All';
export const DROPDOWN_PLACEHOLDER = '---Select---';
export const ALL_SELECTED = 'All Selected';
export const DRAGONFLY_ADVISE_LOADING_MESSAGE = 'Loading Dragonfly Advise';
export const LOADING_MESSAGE = 'Loading';
export const API_REQUEST_TIMEOUT = 30000;
export const GENERAL_ERROR_MESSAGE = 'An error occurred';

export const SEARCH_LABEL = 'SEARCH';
export const RESET_LABEL = 'RESET';
export const YES_LABEL = 'Yes';
export const NO_LABEL = 'No';
export const ACTIVE_LABEL = 'Active';
export const CANCEL_LABEL = 'Cancel';
export const OK_LABEL = 'OK';

export const COPYRIGHT_SYMBOL = '\u00AE';
